import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import clsx from "clsx"

import { Heading } from "src/components/heading"
import { Text } from "src/components/text"

export default function ChatHeader() {
  const { uuid } = useParams()

  const chats = useSelector((state) => state.chat.list)
  const companies = useSelector((state) => state.company.companyList)

  const details = chats.find((chat) => chat.uuid === uuid)
  const company = companies.find((company) => company.uuid === details?.company_uuid)

  return (
    <div className="flex flex-row gap-4 items-center justify-between w-full px-4 sm:px-0 pb-4">
      <Heading className="flex flex-row items-center gap-2 !text-lg sm:!text-xl font-serif">{details?.name}</Heading>
      <div className={clsx("flex-row items-center gap-x-2 flex-wrap", "hidden md:flex")}>
        {company && (
          <>
            {company?.icon && <img src={company.icon} className="w-4 h-4 rounded-sm" alt={company.name} />}
            <Text className="!text-xs">
              {company.name} <span className="text-zinc-500 font-semibold">{company.ticker}</span>
            </Text>
          </>
        )}
        {!company && details?.industry && <Text className="!text-xs ml-2">{details?.industry}</Text>}
        {!company && details?.sector && !details?.industry && <Text className="!text-xs ml-2">{details?.sector}</Text>}
      </div>
    </div>
  )
}
